import React, { useState } from "react";
import styles from "./NewBlockHeader.module.css";
import { Button } from "@mui/material";
import { useRouter } from "next/router";
import ComingSoonModal from "../Modal/ComingSoonModal";
import Head from "next/head";

function NewBlockHeader() {
  const route = useRouter();
  const [copyRightOpen, setCopyRightOpen] = useState(false);
  const copyRightMOdal = () => {
    setCopyRightOpen(true);
  };

  const ScrollSession = () => {
    route.push("/diviner-signup");
  };

  return (
    <>


      <Head>
        <title>Free Astrology And Tarot Courses on YouTube | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Free Astrology Course, Free Tarot Course, YouTube Astrology, YouTube Tarot, Learn Astrology Free, Learn Tarot Free, Divine Theurgy, Diviner Certification"
        ></meta>
        <meta
          property="og:title"
          content="Learn Astrology and Tarot for Free on Our YouTube Channel"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/free_youtube_courses_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="A promotional banner for the School of Our Divine Infinite Being, announcing that all video course material is available for free on YouTube."
        ></meta>
        <meta
          property="og:description"
          content="Access all of our video course material for free on YouTube. Learn the foundations of Astrology and Tarot, then enroll in our certification program for live training and to join our network of professional diviners."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/purchase"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/free_youtube_courses_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="A promotional banner for the School of Our Divine Infinite Being, announcing that all video course material is available for free on YouTube."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/purchase"
        ></meta>
        <meta
          name="twitter:title"
          content="Learn Astrology and Tarot for Free on Our YouTube Channel"
        ></meta>
        <meta
          name="twitter:description"
          content="Access all of our video course material for free on YouTube. Learn the foundations of Astrology and Tarot, then enroll in our certification program for live training and to join our network of professional diviners."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/purchase" />
      </Head>
      <div className={styles.new_blockheader}>
        {/* <div className={styles.new_blockheader_wrpr}>
          <div className={styles.new_blockheader_wrprinner}>
            <span>
              All of our Video Course Material is Available Free on YouTube!
              What we charge for is the Certification, Live Trainings and the
              Privlidge of becoming a Diviner in Astrology and Tarot in our
              Network
            </span>
          </div>
        </div> */}
        <div className={styles.footerNew_block_red_main_wrp}>
          <h3><span>All of our Video Course Material is Available</span> <strong>Free on YouTube!</strong></h3>
          <p><span>What we charge for is the Certification, <br />Live Trainings and the Privilege of <br />becoming a Diviner in Astrology and Tarot in our Network</span></p>
        </div>


        <div className={styles.new_blockbutton_wrpr}>
          <Button className={styles.btn_enrl} onClick={() => ScrollSession()}>
            Enroll Now
          </Button>
          <Button className={styles.btn_youtb} onClick={() => copyRightMOdal()}>
            Go to Our Youtube Channel
          </Button>
        </div>
      </div>

      {copyRightOpen ? (
        <ComingSoonModal
          copyRightOpen={copyRightOpen}
          setCopyRightOpen={setCopyRightOpen}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default NewBlockHeader;
